import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import {
  segment,
  createSegment,
  segments,
} from './fixtures/auto-tagger-service.fixtues';

export const listSegmentsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-auto-tagger-service/segments`,
    fn,
  );
export const deleteSegmentMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-auto-tagger-service/segments/:segmentId`,
    fn,
  );

export const createSegmentMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-auto-tagger-service/segments`,
    fn,
  );

export const deactivateSegmentMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-auto-tagger-service/segments/:segmentId/deactivate`,
    fn,
  );

export const reactivateSegmentMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-auto-tagger-service/segments/:segmentId/reactivate`,
    fn,
  );
export const getSegmentMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-auto-tagger-service/segments/:segmentId`,
    fn,
  );
export const updateSegmentMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-auto-tagger-service/segments/:segmentId`,
    fn,
  );

export const handlers = () => [
  listSegmentsMock((_req, res, ctx) => {
    return res(ctx.json(segments));
  }),
  deleteSegmentMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  createSegmentMock((_req, res, ctx) => {
    return res(ctx.json(createSegment));
  }),
  deactivateSegmentMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  reactivateSegmentMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  getSegmentMock((_req, res, ctx) => {
    return res(ctx.json(segment));
  }),
  updateSegmentMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
];
